export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-steam-b4cbd392f0a76f10e557f04c1c48772d.svg";